import Spinner from "../../../../components/Spinner/Spinner";
import { Container } from "./styles/BlankStyles";

const Blank = () => {
  return (
    <Container>
      <Spinner />
    </Container>
  );
};

export default Blank;
